/**
 * Zugangsregeln für interne Bereiche (z. B. Admin-Tab „Analytics/Credit-Hub“).
 *
 * Single Source of Truth für die **Rolle** in der App ist dieselbe wie in `useAuth` /
 * `quickSubscriptionCheck()`: Spalte `user_private.role` (nicht JWT allein).
 *
 * Hinweis zu `terminal`: Rolle `terminal` erhält über `hasContributorPrivileges` dieselben
 * Host-/Content-Rechte wie `contributor`, ist aber **kein** Ziel für interne KPI-/Support-Hubs
 * (Kiosk-/Terminal-Modus).
 */

export type AppStaffRole =
  | "admin"
  | "contributor"
  | "terminal"
  | "user"
  | null;

/**
 * Liefert true, wenn die Rolle explizit „Contributor“ ist (interner Mitarbeitenden-Zugang).
 */
export function isContributorStaffRole(role: AppStaffRole): boolean {
  return role === "contributor";
}

/**
 * Liefert true, wenn der Nutzer den internen Analytics/Credit-Hub sehen darf.
 *
 * - Admin: voll
 * - Contributor: voll im Hub (MVP; einzelne künftige Unter-Tabs können separat mit `isAdmin` eingeschränkt werden)
 * - Terminal: ausgeschlossen (trotz `hasContributorPrivileges`)
 */
export function canAccessInternalAnalyticsCreditHub(role: AppStaffRole): boolean {
  return role === "admin" || role === "contributor";
}
